import React from 'react';
import {Route, BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import {ThemeProvider} from '@material-ui/core/styles';
import theme from './App.theme';
import { store } from '../Redux/store';
import routes from '../constants/routes';
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import CCExistsPage from "../components/CCStatus/CCExistsPage";
import EnterCCDetailsPage from '../components/EnterCCDetails/EnterCCDetailsPage'
import BasicInformationController from "../components/BasicInformation/BasicInformationController";
import CCDoesNotExist from "../components/CCStatus/CCDoesNotExist";
import CCConfirmation from '../components/CCConfirmation/CCConfirmation';

const App = () => {
    return (
      <ThemeProvider theme={theme}>
        <Provider store={store}>
            <Header/>
            <BrowserRouter basename="/rx-onboarding-ui">
                <Route exact
                       path={routes.PATIENT_LOOKUP}
                       component={BasicInformationController}
                />
                <Route exact
                       path={routes.CC_EXISTS}
                       component={CCExistsPage}
                />
                <Route exact
                       path={routes.CC_DOES_NOT_EXISTS}
                       component={CCDoesNotExist}
                />
                <Route exact
                       path={routes.CC_CONFIRMATION}
                       component={CCConfirmation}
                />
                <Route path={routes.ENTER_CC_DETAILS} component={EnterCCDetailsPage} />
                <Footer/>
            </BrowserRouter>
        </Provider>
      </ThemeProvider>
);
};

export default App;
